import Resource from '@/api/resources/Resource'

class PatientDiscrepancyServices extends Resource {
    async getPendingToResolveLocalPatientDiscrepancies(laboratoryId, requestId) {
        const response = await this.axios.get(`/integration/laboratories/${laboratoryId}/request/${requestId}/localPatientWithDiscrepancies`)
        return response.data
    }
    async getPatientWithDiscrepancy(laboratoryId, requestId) {
        const response = await this.axios.get(`/integration/laboratories/${laboratoryId}/request/${requestId}/patientWithDiscrepancy`)
        return response.data
    }
    async patchLocalPatientPartiallyAndDeleteTemporalPatient(laboratoryId, requestId, patientId, integrationPatientPatchRequest) {
        const response = await this.axios.patch(`/integration/laboratories/${laboratoryId}/request/${requestId}/patient/${patientId}/local`, integrationPatientPatchRequest)
        return response.data
    }
    async patchTemporalPatientPartiallyAndDeleteLocalPatient(laboratoryId, requestId, patientId, integrationPatientPatchRequest) {
        const response = await this.axios.patch(`/integration/laboratories/${laboratoryId}/request/${requestId}/patient/${patientId}/temporal`, integrationPatientPatchRequest)
        return response.data
    }
    async keepLocalPatientWithoutUpdating(laboratoryId, requestId) {
        const response = await this.axios.get(`/integration/laboratories/${laboratoryId}/request/${requestId}/keepLocalPatientWithoutUpdating`)
        return response.data
    }
    async hisPatientWithDiscrepancy(laboratoryId, integrationPatientRequest) {
        const response = await this.axios.put(`/integration/laboratories/${laboratoryId}/patients/hisPatientWithDiscrepancy`, integrationPatientRequest)
        return response.data
    }
    async patientWithOrWithoutDiscrepancy(laboratoryId, integrationPatientRequest) {
        const response = await this.axios.put(`/integration/laboratories/${laboratoryId}/patients/patientWithOrWithoutDiscrepancy`, integrationPatientRequest)
        return response.data
    }
    async updateLocalPatientPartiallyWithHisPatientInformation(laboratoryId, patientId, integrationPatientPatchRequest) {
        const response = await this.axios.patch(`/integration/laboratories/${laboratoryId}/patient/${patientId}/local`, integrationPatientPatchRequest)
        return response.data
    }
}

export default new PatientDiscrepancyServices()
